import { Button, Form, Modal, Space } from "antd"
import React from "react"
import { TextArea } from "../Input/TextArea.tsx"

interface FormData {
  reason: string
}

export type DocumentReviewRejectModalMode = "revision" | "cancel"

interface DocumentReviewRejectModalProps {
  mode: DocumentReviewRejectModalMode
  onClose: () => void
  onSubmit: (reason: string) => void
  saving: boolean
}

const MODE_COPY: Record<
  DocumentReviewRejectModalMode,
  {
    title: string
    placeholder: string
    requiredMessage: string
    submitLabel: string
    submitDanger: boolean
  }
> = {
  revision: {
    title: "Reason for under revision",
    placeholder: "Describe what needs to be revised...",
    requiredMessage: "Please specify the reason",
    submitLabel: "Submit",
    submitDanger: false
  },
  cancel: {
    title: "Reason for cancellation",
    placeholder: "Enter cancellation reason...",
    requiredMessage: "Please specify the reason for cancellation",
    submitLabel: "Confirm cancel",
    submitDanger: true
  }
}

export function DocumentReviewRejectModal({
  mode,
  onClose,
  onSubmit,
  saving
}: DocumentReviewRejectModalProps) {
  const [form] = Form.useForm<FormData>()
  const copy = MODE_COPY[mode]

  const onFinish = ({ reason }: FormData) => {
    onSubmit(reason)
  }

  return (
    <Modal open title={copy.title} onCancel={onClose} footer={null}>
      <Form
        form={form}
        clearOnDestroy
        onFinish={onFinish}
        layout="vertical"
        className={"flex-1 flex gap-3 flex-col w-full with-default-error"}
        validateTrigger={["onSubmit", "onChange"]}
        disabled={saving}
      >
        <Form.Item<FormData>
          name={"reason"}
          rules={[
            {
              required: true,
              whitespace: true,
              message: copy.requiredMessage
            },
            { min: 10, message: "Reason must be at least 10 characters" }
          ]}
        >
          <TextArea rows={4} placeholder={copy.placeholder} />
        </Form.Item>
        <Space className={"self-end"}>
          <Button onClick={onClose}>Close</Button>
          <Button type="primary" danger={copy.submitDanger} htmlType="submit">
            {copy.submitLabel}
          </Button>
        </Space>
      </Form>
    </Modal>
  )
}
